import React, { Component } from "react";
import Coin from "../Coin/Coin";
import Asd from "./Asd";
import "./CoinFlipper.css";
import Countdown from 'react-countdown';

class CoinFlipper extends Component {

  constructor(props) {
    super(props);
    // State üzerinde paranın başlangıçtaki durumunu veriyoruz, başlangıçta "tura" olsun.
    // Daha sonra şu anda paranın dönüp dönmeme durumunu da veriyoruz, başlangıçta para atılmamış olduğundan "false" olarak verdik.
    this.state = {
      side: "tail",
      flipping: false,
      total: { totalCount: 0, totalTail: 0, totalHead: 0 },
    };
  }


  handleClick = () => {
    this.state.total.totalCount++;
    var oneOrZero = Math.random();
    if (oneOrZero < 0.5) {
      oneOrZero = 0;
      this.setState({ side: "head" });
      this.state.total.totalHead++;
    } else {
      oneOrZero = 1;
      this.setState({ side: "tail" });
      this.state.total.totalTail++;
    }
    this.setState({ flipping: true });
    setTimeout(() => this.setState({ flipping: false }), 1000);
  };

  render() {
    return (
      <div className="h-full CoinFlipper">
        <div className="flex w-fulljustify-center items-center">

          <Asd />

        </div>
        <footer className="absolute bottom-10 px-10 w-full  flex justify-between items-center">
          <p className="text-gray-400">Game launching: Coming soon  {/* <Countdown date={Date.now() + 200000000} /> */}
          </p>

          <p className="text-gray-400 mr-20">Coin Flip Faces © Copyright 2022 All rights reserved. </p>
        </footer>
      </div>
    );
  }
}

export default CoinFlipper;
